import React from 'react';

const ContextMenuContainer = ({pageId}) => {
  return (
    <div
      id={`context-menu-container-${pageId}`}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 3001,
      }}
    />
  );
};

export default ContextMenuContainer;
